import cx from "classnames";
import { type FC, type InputHTMLAttributes } from "react";

interface EditInPlaceInputProps extends InputHTMLAttributes<HTMLInputElement> {
	textSize?: "sm" | "md";
}

export const EditInPlaceInput: FC<EditInPlaceInputProps> = ({
	textSize = "sm",
	className,
	...rest
}) => (
	<input
		{...rest}
		className={cx(
			"w-full",
			`input-text--${textSize}`,
			`text-${textSize}`,
			"shadow-border-underline-input",
			"block",
			"text-primary",
			"bg-transparent",
			"focus:ring-0",
			"focus:outline-none",
			className
		)}
	/>
);
